import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80 dark:bg-[#82aaff] dark:text-[#011627]",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80 dark:bg-[#1d3b53] dark:text-[#d6deeb]",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80 dark:bg-[#ff5874] dark:text-white",
        outline: "text-foreground dark:text-[#d6deeb] dark:border-[#1d3b53]",
        success: "border-transparent bg-green-100 text-green-800 dark:bg-[#c3e88d]/15 dark:text-[#c3e88d]",
        warning: "border-transparent bg-yellow-100 text-yellow-800 dark:bg-[#ffcb6b]/15 dark:text-[#ffcb6b]",
        info: "border-transparent bg-blue-100 text-blue-800 dark:bg-[#82aaff]/15 dark:text-[#82aaff]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
